import React from 'react'

export const createColumns = (navigateToManage: (supplierName: string) => void) => [
  {
    Header: 'Posição',
    id: 'position',
    accessor: 'position',
    width: 100,
    getProps: (state, rowInfo) => ({
      style: {
        fontSize: '24px',
        color:
        rowInfo
          && rowInfo.original
          && rowInfo.original.hasIssue
          ? 'red'
          : '',
        textAlign: 'center',
        fontWeight: 600,
      },
    }),
  },
  {
    Header: 'Fornecedor',
    id: 'supplier',
    accessor: 'supplier',
    getProps: (state, rowInfo) => ({
      style: {
        color:
        rowInfo
          && rowInfo.original
          && rowInfo.original.hasIssue
          ? 'red'
          : '',
      },
      title: `Notas associadas: ${rowInfo?.original?.invoiceNumbers}`,
    }),
  },
  {
    Header: 'Senha',
    id: 'password',
    accessor: 'password',
    width: 100,
  },
  {
    Header: 'Pendências',
    id: 'issues',
    accessor: 'issues',
    width: 200,
    Cell: ({ value, row }: { value: string; row: any }) => {
      if (!value) {
        return React.createElement('span', null, value)
      }

      const supplierText = row?.supplier || ''

      const [supplierName] = supplierText.includes(' - ')
        ? supplierText.split(' - ')
        : [supplierText]

      const cleanSupplierName = supplierName.trim()

      return React.createElement('div', {
        role: 'button',
        tabIndex: 0,
        style: {
          cursor: 'pointer',
          fontStyle: 'italic',
        },
        onClick: () => navigateToManage(cleanSupplierName),
      }, value)
    },
  },
  {
    Header: 'Horário Chegada',
    id: 'arrival',
    accessor: 'arrival',
    width: 200,
  },
  {
    Header: 'Tempo Aguardando',
    id: 'waitTime',
    accessor: 'waitTime',
    width: 170,
  },
  {
    Header: 'Ações',
    id: 'actions',
    accessor: 'actions',
    width: 90,
  },
]
